import ApiClient from "./client";
import ServiceRoleGateway from "@/usecases/gateways/service-role-gateway";

export default class ServiceRoleApi implements ServiceRoleGateway {
  public constructor(private client: ApiClient) {}

  /**
   * 権限を付与する
   */
  public async assign(staffId: number, roleId: number) {
    const d = new FormData();
    d.append("staffId", String(staffId));
    d.append("serviceRoleId", String(roleId));
    await this.client.post("assign_service_role.php", d);
  }

  /**
   * 権限を剥奪する
   */
  public async remove(staffId: number) {
    const d = new FormData();
    d.append("staffId", String(staffId));
    await this.client.post("remove_service_role.php", d);
  }
}
